/* ChainLine Cycle — Theme JS */
(function () {
  'use strict';

  // ── Header scroll behaviour ──────────────────────────────────
  const header = document.querySelector('.site-header');
  const isHomepage = document.querySelector('.hero') !== null;

  function setHeaderState() {
    if (!header) return;
    const solid = window.scrollY > window.innerHeight * 0.45;
    header.classList.toggle('site-header--solid', solid || !isHomepage);
    header.classList.toggle('site-header--hero', !solid && isHomepage);
  }

  if (header) {
    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
  }

  // ── Mobile navigation ────────────────────────────────────────
  const menuToggle  = document.querySelector('.header-menu-toggle');
  const mobileNav   = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');
  const overlay     = document.getElementById('page-overlay');

  function openNav() {
    mobileNav?.classList.add('is-open');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    menuToggle?.setAttribute('aria-expanded', 'true');
  }
  function closeNav() {
    mobileNav?.classList.remove('is-open');
    if (!cartOpen) overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
    menuToggle?.setAttribute('aria-expanded', 'false');
  }

  menuToggle?.addEventListener('click', openNav);
  mobileClose?.addEventListener('click', closeNav);

  // ── Cart drawer ──────────────────────────────────────────────
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartContent = document.getElementById('cart-drawer-content');
  const cartClose   = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  let cartOpen = false;

  function openCart() {
    cartOpen = true;
    cartDrawer?.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    renderCart();
  }
  function closeCart() {
    cartOpen = false;
    cartDrawer?.setAttribute('aria-hidden', 'true');
    if (!mobileNav?.classList.contains('is-open')) {
      overlay?.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }

  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', () => { closeNav(); closeCart(); });

  document.querySelectorAll('[data-open-cart]').forEach(el =>
    el.addEventListener('click', openCart)
  );

  async function renderCart() {
    if (!cartContent) return;
    cartContent.innerHTML = '<p style="color:var(--cl-gray-400);padding:2rem 0;text-align:center;">Loading…</p>';
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      if (cart.item_count === 0) {
        cartContent.innerHTML = `
          <div style="text-align:center;padding:3rem 1rem;">
            <p style="font-family:var(--font-display);font-size:var(--text-lg);font-weight:700;text-transform:uppercase;margin-bottom:1rem;">Your cart is empty</p>
            <p style="font-size:var(--text-sm);color:var(--cl-gray-500);margin-bottom:2rem;">Add some bikes or gear to get started.</p>
            <a href="/collections/all" class="btn btn-primary">Shop Now</a>
          </div>`;
        return;
      }
      const items = cart.items.map(item => `
        <div style="display:flex;gap:1rem;padding:1.25rem 0;border-bottom:1px solid var(--cl-gray-100);">
          <img src="${item.image}" alt="${item.title}"
               style="width:76px;height:76px;object-fit:cover;background:var(--cl-gray-50);flex-shrink:0;">
          <div style="flex:1;min-width:0;">
            <p style="font-size:var(--text-xs);letter-spacing:.1em;text-transform:uppercase;color:var(--cl-gray-400);margin-bottom:.2rem;">${item.vendor}</p>
            <p style="font-family:var(--font-display);font-weight:600;font-size:var(--text-sm);line-height:1.3;margin-bottom:.35rem;">${item.product_title}</p>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:var(--text-xs);color:var(--cl-gray-500);margin-bottom:.35rem;">${item.variant_title}</p>` : ''}
            <p style="font-family:var(--font-display);font-weight:600;font-size:var(--text-sm);">${fmt(item.final_price)}</p>
          </div>
        </div>`).join('');

      cartContent.innerHTML = `
        <div>${items}</div>
        <div style="margin-top:1.5rem;padding-top:1.5rem;border-top:1px solid var(--cl-gray-200);">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:1.5rem;">
            <span style="font-family:var(--font-display);font-weight:700;text-transform:uppercase;letter-spacing:.06em;font-size:var(--text-sm);">Subtotal</span>
            <span style="font-family:var(--font-display);font-weight:700;font-size:var(--text-lg);">${fmt(cart.total_price)}</span>
          </div>
          <a href="/checkout" class="btn btn-primary" style="width:100%;justify-content:center;display:flex;margin-bottom:.75rem;">Checkout</a>
          <a href="/cart" style="display:block;text-align:center;font-size:var(--text-xs);color:var(--cl-gray-500);text-decoration:underline;text-underline-offset:3px;">View full cart</a>
        </div>`;
      updateCartCount(cart.item_count);
    } catch (e) {
      cartContent.innerHTML = '<p style="color:var(--cl-gray-400);padding:1rem 0;">Could not load cart. Please refresh.</p>';
    }
  }

  function fmt(cents) {
    return new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(cents / 100);
  }

  function updateCartCount(n) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  // ── Add to cart (AJAX) ───────────────────────────────────────
  document.querySelectorAll('[data-atc-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        const fd = new FormData(form);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || 1) })
        });
        btn.textContent = 'Added!';
        await renderCart();
        setTimeout(openCart, 250);
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1800);
      } catch {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      }
    });
  });

  // ── Scroll-triggered fade-up ─────────────────────────────────
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    document.querySelectorAll('.fade-up').forEach(el => io.observe(el));
  }

  // ── Newsletter form ──────────────────────────────────────────
  document.querySelectorAll('[data-newsletter]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn   = form.querySelector('button[type="submit"]');
      const input = form.querySelector('input[type="email"]');
      btn.textContent = 'Subscribing…';
      btn.disabled = true;
      try {
        const body = new FormData(form);
        await fetch(form.action, { method: 'POST', body });
        input.value = '';
        btn.textContent = 'Subscribed!';
      } catch {
        btn.textContent = 'Subscribe';
        btn.disabled = false;
      }
    });
  });

})();
